/**
 * Hook for managing client locking functionality
 */

import { useState } from 'react';

/**
 * Custom hook for client locking state and functions
 * @returns {Object} Client locking state and utility functions
 */
const useClientLocking = () => {
  const [lockedClients, setLockedClients] = useState(new Set()); // Clients locked to top

  // Utility function to get unique client key
  const getClientKey = (client) => `${client.client_name}-${client.country}`;

  // Lock/unlock client to top
  const isClientLocked = (client) => {
    return lockedClients.has(getClientKey(client));
  };

  const toggleClientLock = (client) => {
    const clientKey = getClientKey(client);
    const newLockedClients = new Set(lockedClients);
    
    if (newLockedClients.has(clientKey)) {
      newLockedClients.delete(clientKey);
    } else {
      newLockedClients.add(clientKey);
    }
    
    setLockedClients(newLockedClients);
  };

  return {
    lockedClients,
    isClientLocked,
    toggleClientLock,
    setLockedClients
  };
};

export default useClientLocking;
